// extracted by mini-css-extract-plugin
export var dividerLine = "_bf-3";
export var itemImage = "_bf-9";
export var lightDivider = "_bf-4";
export var modalContent = "_bf-5";
export var modalContentCompact = "_bf-6";
export var productCard = "_bf-a";
export var productImage = "_bf-b";
export var productImageCompact = "_bf-7";
export var productImagePlaceholder = "_bf-c";
export var productImagePlaceholderCompact = "_bf-8";
export var progressBarBackground = "_bf-1";
export var progressBarContainer = "_bf-0";
export var progressBarFill = "_bf-2";